import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const TabItem = ({ label, value, currentValue, href }) => {
  const isActive = value === currentValue;
  return (
    <a
      href={href}
      className={`flex items-center justify-center h-[24px] w-[75px] text-[11px] font-inter-semibold ${isActive ? "bg-white text-[#252526]" : "bg-[#F5F5F5] text-[#686A68]"}`}
    >
      {label}
    </a>
  );
};

const Tabs = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentValue = useMemo(() => {
    if (currentPath === "/showing-activity/feed") {
      return "feed";
    }
    return "marketing";
  }, [currentPath]);

  return (
    <div className="p-0.5 rounded-[5px] bg-[#F5F5F5] flex items-center">
      <TabItem href="/showing-activity/feed" label="Feed" value="feed" currentValue={currentValue} />
      <TabItem href="/showing-activity/marketing" label="Marketing" value="marketing" currentValue={currentValue} />
    </div>
  );
};

export default Tabs;